/* eslint-disable no-undef */
import Cookies from "js-cookie";

const DEV_PREPROD_URLS = {
  dev: process.env.REACT_APP_API_DEV,
  preprod: process.env.REACT_APP_APP_API,
};

// Real production builds always hit REACT_APP_API_PROD — the dev/preprod
// cookie (set by mvp-next's login-page environment toggle) only applies to
// development/test builds, so it can never redirect production traffic.
export function getApiBaseUrl() {
  if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_API_PROD;
  }

  const selected = Cookies.get("app-environment") === "preprod" ? "preprod" : "dev";
  return DEV_PREPROD_URLS[selected] || DEV_PREPROD_URLS.dev;
}
